import { ApexOptions } from 'apexcharts';
import styles from './index.module.sass';
import Chart from 'react-apexcharts';
import { useEffect } from 'react';
import {
  $priceDynamicsByBuyer,
  fetchPriceDynamixById,
  setInitialStateDynamicsById,
} from '@/modules/seller-account/store/buyers.store';
import { useStore } from 'effector-react';
import { generateOptions } from '@/modules/seller-account/functions/generate-options.function';
import { notification } from 'antd';

export const StatsTab = ({ buyerId }: { buyerId: number }) => {
  const data = useStore($priceDynamicsByBuyer);
  const helperArray = [1, 2, 3, 4, 5];

  const reformedData = ((data: any) => {
    const temp: Record<string, any[]> = {
      '1': [],
      '2': [],
      '3': [],
      '4': [],
      '5': [],
    };
    if ('error' in data) {
      return temp;
    }
    data?.map((item: any) => {
      item.price_type in temp && temp[item.price_type].push(item);
    });

    for (var key in temp) {
      if (temp.hasOwnProperty(key)) {
        temp[key].sort(function (a: any, b: any) {
          const aDate: any = new Date(a.created_at);
          const bDate: any = new Date(b.created_at);
          return aDate - bDate;
        });
      }
    }
    return temp;
  })(data);

  useEffect(() => {
    fetchPriceDynamixById(buyerId);
    return () => setInitialStateDynamicsById();
  }, []);

  const isEmptyData = (() => {
    if ('error' in reformedData) return true;
    const res = helperArray?.map((item) => {
      if (reformedData[item.toString()].length < 2) return;
      return item;
    });

    const allUndefined = res.every((element) => element === undefined);
    return allUndefined;
  })();

  return (
    <div className={styles.root}>
      <div className={styles.chartsScrollable}>
        {!isEmptyData ? (
          helperArray.map((item) => {
            if (reformedData[item.toString()].length < 2) return;
            return (
              <div className={styles.statsItem}>
                <span className={styles.heading}>{item} класс</span>
                <Chart
                  height={300}
                  options={generateOptions(reformedData[item.toString()])}
                  series={generateOptions(reformedData[item.toString()]).series}
                  type="area"
                  // onWheel={handleScroll}
                />
              </div>
            );
          })
        ) : (
          <div className={styles.placeholder}>
            <span>
              {data?.error?.error ||
                'Недостаточно данных для формирования статистики. Попробуйте, пожалуйста, позже'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
